import React from 'react';
import AboutMainWrap from "../style/wrap";
import Container from "../../../../components/paper/container";
import SectionTitle from "../../../../components/heading/section";
import {Button, Card, Col, Row, Space} from "antd";
import CardTitle from "../../../../components/heading/card";
import styled from "styled-components"
import {Icon} from '@iconify/react';
import AuthLayout from '../../../../layouts/auth.layout';
import P1 from "../../../../components/paragraph";

const AboutMain = () => {
    return (
        <AboutMainWrap>
            <Container>
                <Space direction='vertical' size={32} style={{width: '100%', paddingTop: '0px'}}>  
                    <Row gutter={[32, 32]}>
                        <Col lg={{span: 3}} span={AuthLayout}>
                            
                        </Col>
                        <Col lg={{span: 18}} span={AuthLayout} style={{width: '80%', justifyContent: 'center'}}>
                            <Space direction='vertical' style={{width: '100%' }} size={32}>
                                <ActionFormCard>
                                <CardTitle style={{marginBottom: 20}}>
                                    Pricing
                                </CardTitle>
                                <CardTitle style={{marginBottom: 20}}>
                                    {/* <img
                                        src={'https://freearianna.org/static/media/paypalqrcode.9f13c28557abe5d13a0c.png'}
                                        alt=""/> */}
                                </CardTitle>
                            </ActionFormCard>
                            </Space>
                        </Col>
                        <Col lg={{span: 3}} span={AuthLayout}>
                            
                        </Col>
                    </Row>
                </Space>
            </Container>
        </AboutMainWrap>
    );
};

const ActionFormCard = styled(Card)`
  box-shadow: none;
  border: none;
  background: linear-gradient(to top, #f4e1ff, #f4e1ff);
  border-radius: 12px;
  padding: 0px;

  h2 {
    text-align: center;
    //font-size: 28px;
    margin-bottom: 0px;
  }

  h3 {
    font-size: 24px;
    text-align: center;
    margin-bottom: 0px;
  }

  @media (max-width: 768px) {
    padding: 0;
  }
`

export default AboutMain;
